import React, { useEffect } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface LanguageRouteProps {
  children: React.ReactNode;
}

const LanguageRoute: React.FC<LanguageRouteProps> = ({ children }) => {
  const { lang } = useParams<{ lang: string }>();
  const navigate = useNavigate();
  const location = useLocation();
  const { i18n } = useTranslation();

  useEffect(() => {
    const validLanguages = ['tr', 'en'];
    const currentLang = lang || 'tr';

    if (!validLanguages.includes(currentLang)) {
      // Redirect to default language if invalid
      const pathWithoutLang = location.pathname.replace(/^\/(tr|en)/, '') || '/home';
      navigate(`/tr${pathWithoutLang}`, { replace: true });
      return;
    }

    // Change i18n language
    if (i18n.language !== currentLang) {
      i18n.changeLanguage(currentLang);
      // Update document language
      document.documentElement.lang = currentLang;
    }
  }, [lang, i18n, navigate, location.pathname]);

  return <>{children}</>;
};

export default LanguageRoute;

